import React, { useEffect } from 'react';
import { Card, Col, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AuthForm, { STATE_LOGIN } from '../components/AuthForm';
import { loginUser } from '../states/actions/loginAction';
import { registerUser } from '../states/actions/userAction';
import { handleError, handleSuccess } from '../utils/toast';
import { ToastContainer } from '../utils/toast';

const AuthPage = ({ authState }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userLogin = useSelector(state => state.userLogin); // adjust path based on your reducer structure
  const loading = useSelector(
    state => state.userLogin.loading || state.users.loading,
  );

  const handleAuthState = authState => {
    if (authState === STATE_LOGIN) {
      navigate('/login');
    } else {
      navigate('/signup');
    }
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  // Handle login result
  useEffect(() => {
    if (userLogin?.userLogin?.success) {
      handleSuccess('Logged in successfully');
      setTimeout(() => {
        navigate('/dashboard');
        window.location.reload();
      }, 500);
    } else if (userLogin?.userLogin?.error === 'Rejected') {
      handleError('Invalid credentials');
    }
  }, [userLogin, navigate]);

  // 🔑 Submit handler passed to AuthForm
  const handleSubmit = async (payload, authState) => {
    if (authState === STATE_LOGIN) {
      dispatch(loginUser(payload));
    } else {
      try {
        const resultAction = await dispatch(registerUser(payload));

        if (registerUser.fulfilled.match(resultAction)) {
          //handleSuccess('Registered successfully');
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        } else {
          handleError(resultAction.payload?.message || 'Registration failed');
        }
      } catch (error) {
        handleError('Something went wrong during registration');
      }
    }
  };

  return (
    <Row
      style={{
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Col md={6} lg={4}>
        <Card body>
          <AuthForm
            authState={authState}
            onChangeAuthState={handleAuthState}
            onLogoClick={handleLogoClick}
            onSubmit={handleSubmit} // Pass your Redux dispatch handler
            loading={loading}
          />
        </Card>
      </Col>
      <ToastContainer />
    </Row>
  );
};

export default AuthPage;
